import { useSelector } from 'react-redux';
import { combineReducers } from 'redux';
// @ts-expect-error not migrated yet
import { applyDiff } from 'editor-iframe-lib/redux/utils/iframeStateSync';
import resources from 'ContentData/reducers/Resources';

// @ts-expect-error not migrated yet
import reduceReducers from 'ContentEditorUI/utils/reduceReducers';
// @ts-expect-error not migrated yet
import iframesReducer from 'ContentEditorUI/redux/reducers/iframesReducer';
import EmailDragDropSyncConfigManager from 'EmailEditorUI/redux/inpageSync/EmailDragDropSyncConfigManager';
import emailDragDropSyncConfig from 'EmailEditorUI/redux/inpageSync/emailDragDropConfig';
import emailTemplateEditorConfig from 'EmailEditorUI/redux/inpageSync/emailTemplateEditorConfig';
import customConfig from 'EmailEditorUI/redux/inpageSync/customConfig';
import EmailCustomSyncConfigManager from 'EmailEditorUI/redux/inpageSync/EmailCustomSyncConfigManager';
import { emailContentModelReducer } from 'EmailEditorUI/redux/reducers/emailContentModelReducer';
// @ts-expect-error not migrated yet
import rssFeedUrlValidationReducer from 'EmailData/reducers/rssFeedUrlValidation';
import sidebarTab from 'LayoutBuilderUI/reducers/sidebarTab';
import userInterfaceReducer from 'LayoutBuilderUI/reducers/userInterface';
import fileUploads from 'LayoutBuilderUI/reducers/fileUploads';
const emailDragDropConfig = emailDragDropSyncConfig();
const emailCustomConfig = customConfig();
export const useAppSelector = useSelector;
const SIMPLE_REDUCER = (state = null) => state;
const withSyncedReducers = (appReducers, config, syncOverrides = {}) => {
  const fakeSyncConfigReducers = Object.keys(config).reduce((acc, cur) => {
    acc[cur] = SIMPLE_REDUCER;
    return acc;
  }, {});
  const clashingKeys = Object.keys(fakeSyncConfigReducers).filter(key => {
    return !!appReducers[key];
  });
  if (clashingKeys.length) {
    console.warn(`Some synced state keys also have real reducers assigned to them`, clashingKeys);
  }
  const stateSyncReducer = (state = {}, {
    type,
    diff
  }) => {
    switch (type) {
      case 'SYNC_INAPP_STATE':
        {
          return applyDiff(diff, state, {
            config
          });
        }
      default:
        return state;
    }
  };
  const reducersCombined = combineReducers(Object.assign({}, appReducers, fakeSyncConfigReducers, syncOverrides));
  return reduceReducers(reducersCombined, stateSyncReducer);
};
const getIsCustomEmail = initialState => !!(initialState.extraInitialState && initialState.extraInitialState.isCustomEmail);
const getAppReducers = isCustomEmail => Object.assign({
  sidebarTab,
  userInterface: userInterfaceReducer,
  fileUploads,
  resources,
  iframes: iframesReducer
}, isCustomEmail && {
  configValues: (state = {}) => state
});
const getIsTemplateEditor = initialState => initialState.contentReadOnlyData.isEmailTemplateEditor;
const getReducerConfig = initialState => {
  const isCustomEmail = getIsCustomEmail(initialState);
  if (isCustomEmail) {
    return EmailCustomSyncConfigManager.getConfig();
  }
  return getIsTemplateEditor(initialState) ? emailTemplateEditorConfig : EmailDragDropSyncConfigManager.getConfig();
};
const getSyncOverrides = (isCustomEmail, isTemplateEditor = false) => {
  if (!isCustomEmail && !isTemplateEditor) {
    return {
      contentModel: emailContentModelReducer,
      rssFeedUrlValidation: rssFeedUrlValidationReducer
    };
  }
  return {};
};
export function getRootReducer(initialState) {
  const isCustomEmail = getIsCustomEmail(initialState);
  const isTemplateEditor = getIsTemplateEditor(initialState);
  const syncOverrides = getSyncOverrides(isCustomEmail, isTemplateEditor);
  const appReducers = getAppReducers(isCustomEmail);
  const reducerConfig = getReducerConfig(initialState);
  return withSyncedReducers(appReducers, reducerConfig, syncOverrides);
}